import { Link, useLocation } from "react-router-dom";



const AdminBillingHeader = ({ customerId }) => {
    // console.log('✌️customerId ++++', customerId);
    const tabs = [
        { name: "COD Remittance", path: "/codRemmitanceAdmin", state: { customerId: customerId } },
        { name: "Wallet Transactions", path: "/wallettransactionsAdmin", state: { customerId: customerId } },
        { name: "Shipping Charges", path: "/shippingchargesAdmin", state: { customerId: customerId } },
        // { name: "New Weight Reconciliation", path: "/newweightreconciliation" },
    ];
    const location = useLocation();
    return (
        <div className="px-6 pt-6 pb-2 bg-white rounded-lg">
            <h2 className="text-xl font-bold">Billing - COD Remittance</h2>

            <div className="mt-4 flex flex-wrap gap-2 border-b">
                {tabs?.map((tab) => (
                    <Link
                        key={tab?.name}
                        to={{ pathname: tab?.path, state: tab?.state }}
                        state={{ state: tab?.state }}
                        className={`px-4 py-2 text-sm relative transition-all duration-200 ${location?.pathname === tab?.path
                            ? "font-semibold text-black after:absolute after:bottom-0 after:left-0 after:w-full after:h-[2px] after:bg-black"
                            : "text-gray-600 hover:text-black"
                            }`}
                    >
                        {tab?.name}
                    </Link>
                ))}
            </div>
        </div>
    )
}

export default AdminBillingHeader
